module.exports = __webpack_public_path__ + "static/media/clampex-assistant-spacecenter.8916f55e.png";